import { ISection } from '@sdk/contracts';
import { useMemo, useState } from 'react';

export const useSearchSections = (sections: ISection[] = []) => {
  const [searchValue, setSearchValue] = useState('');

  const filteredSections = useMemo(
    () =>
      sections.filter(
        section =>
          section.name.toLowerCase().includes(searchValue.toLowerCase()) ||
          section.activities.some(activity =>
            activity.name.toLowerCase().includes(searchValue.toLowerCase())
          )
      ),
    [sections, searchValue]
  );

  return {
    searchValue,
    setSearchValue,
    filteredSections
  };
};
